<template>
  <van-action-sheet
    v-model="floatLayoutVisable"
    title="标题"
    class="action-sheet"
  >
    <div class="content">
      <div class="emojiWrapper">
        <div
          class="emojiItem"
          @click="selectType(0)"
        >
          <img
            class="emoji"
            :src="type === 0 ? happyActive : happy"
          >
          <span class="emojiText">非常满意</span>
        </div>
        <div
          class="emojiItem"
          @click="selectType(1)"
        >
          <img
            class="emoji"
            :src="type === 1 ? generalActive : general"
          >
          <span class="emojiText">一般</span>
        </div>
        <div
          class="emojiItem"
          @click="selectType(2)"
        >
          <img
            class="emoji"
            :src="type === 2 ? unhappyActive : unhappy"
          >
          <span class="emojiText">不满意</span>
        </div>
      </div>
      <div class="tags">
        <div
          v-for="item in tags"
          :key="item.name"
          class="tag"
          :class="{
            checked: item.checked
          }"
          @click="selectTag(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="btnwrap">
        <van-button
          type="primary"
          :loading="loading"
          block
          class="btn"
          @click="handleSubmit"
        >
          提交
        </van-button>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
import {
  ActionSheet,
  Button,
  Toast,
} from 'vant';
import general from '@/assets/emoji/general.png';
import generalActive from '@/assets/emoji/general_active.png';
import happy from '@/assets/emoji/happy.png';
import happyActive from '@/assets/emoji/happy_active.png';
import unhappy from '@/assets/emoji/unhappy.png';
import unhappyActive from '@/assets/emoji/unhappy_active.png';
import { getFeedbackBarInfo, recordFeedbackInfo } from '@/api/feedback';
import { mapState } from 'vuex';
import { mapVant } from '@/utils';

export default {
  components: {
    ...mapVant(
      ActionSheet,
      Button,
    ),
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      general,
      generalActive,
      happy,
      happyActive,
      unhappy,
      unhappyActive,
      floatLayoutVisable: false,
      type: null,
      loading: false,
      tags: [],
      feedbackTitle: '本次换电感受如何？',
    };
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async show() {
      const {
        feedbackInfo,
        feedbackTitle,
      } = await getFeedbackBarInfo();
      Object.assign(this, {
        feedbackTitle,
        tags: feedbackInfo.map((v) => ({
          name: v,
          checked: false,
        })),
      });
      this.floatLayoutVisable = true;
    },
    selectType(type) {
      this.type = type;
    },

    selectTag(tag) {
      if (!tag.checked && this.tags.filter((v) => v.checked).length >= 3) {
        Toast('最多可选择3个标签');
      } else {
        tag.checked = !tag.checked;
      }
    },

    closeLayout() {
      Object.assign(this, {
        floatLayoutVisable: false,
        type: null,
        tags: [],
        feedbackTitle: '本次换电感受如何？',
      });
    },

    async handleSubmit() {
      this.loading = true;
      try {
        await this.onSubmit();
      } finally {
        this.loading = false;
      }
    },

    async onSubmit() {
      const { type, tags, user } = this;
      if (type === null) {
        Toast('未选择满意度');
        return;
      }
      const { cityCode, adCode } = await this.$store.dispatch('location/getLocation');
      const params = {
        ...this.params,
        userId: user.userGuid,
        userPhone: user.mobile,
        cityCode,
        adCode,
        satisfaction: type,
        feedbackInfo: tags.filter((v) => v.checked).map((v) => v.name),
      };
      try {
        await recordFeedbackInfo(params);
      } catch (e) {
        Toast(e.message);
      } finally {
      // this.submitDisable = false;
      }

      this.closeLayout();
      Toast('感谢您的反馈');
    },
  },
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>
